import { ObjectMap } from '@ringcentral-integration/core/lib/ObjectMap';

export const trackEvents = ObjectMap.fromObject({
  outbound: 'Outbound Call',
  mute: 'Call Control: Mute',
  unmute: 'Call Control: Unmute',
  hold: 'Call Control: Hold',
  unhold: 'Call Control: Unhold',
  record: 'Call Control: Record',
  stopRecord: 'Call Control: Stop Record',
  hangup: 'Call Control: Hang up',
  answer: 'Call Control: Answer',
  voicemail: 'Call Control: To voicemail',
  ignore: 'Call Control: Ignore',
  holdAndAnswer: 'Call Control: Hold and answer',
  endAndAnswer: 'Call Control: End and answer',
  switch: 'Call Control: Switch',
  confirmSwitch: 'Call Control: Confirm switch',
  forward: 'Call Control: Forward',
  confirmForward: 'Call Control: Confirm forward',
  dialpadOpen: 'Call Control: Open dialpad/Call log page',
  dialpadClose: 'Call Control: Close dialpad/Call log page',
  clickTransfer: 'Call Control: Transfer',
  transfer: 'Call Control: Cold transfer/Transfer page',
  authentication: 'Authentication',
  logout: 'Logout',
  callAttemptWebRTC: 'Call Attempt WebRTC',
  callAttempt: 'Call Attempt',
  outboundWebRTCCallConnected: 'Outbound WebRTC Call Connected',
  outboundCallConnected: 'Outbound Call Connected',
  webRTCRegistration: 'WebRTC registration',
  smsAttempt: 'SMS Attempt',
  smsSentSuccessfully: 'SMS: SMS sent successfully',
  smsSentFailed: 'SMS: SMS sent failed',
  logCall: 'Log Call',
  logSMS: 'Log SMS',
  clickToDial: 'Click To Dial',
  callPlaceRingOutCallClickToDial: 'Call: Place RingOut call/Click to Dial ',
  clickToSMS: 'Click To SMS',
  clickToLetUserDecide: 'C2D/S: Let user decide',
  userDecideCall: 'C2D/S: Click Call/Let user decide page',
  userDecideSMS: 'C2D/S: Click SMS/Let user decide page',
  userDecideClose: 'C2D/S: Click Close/Let user decide page',
  viewEntityDetails: 'View Entity Details',
  addEntity: 'Add Entity',
  editCallLog: 'Edit Call Log',
  editSMSLog: 'Edit SMS Log',
  inboundWebRTCCallConnected: 'Inbound WebRTC Call Connected',
  coldTransferCall: 'Cold Transfer Call',
  clickToDialTextList: 'Click To Dial (Text List)',
  clickToDialVoicemailList: 'Click To Dial (Voicemail List)',
  clickToSMSVoicemailList: 'Click to SMS (Voicemail List)',
  deleteVoicemail: 'Delete Voicemail',
  deleteFax: 'Delete Fax',
  flagVoicemail: 'Flag Voicemail',
  clickToDialContactDetails: 'Click To Dial (Contact Details)',
  clickToSMSContactDetails: 'Click To SMS (Contact Details)',
  clickToDialCallHistory: 'Click To dial (Call History)',
  clickToDialCallHistoryWithRingOut: 'Call: Place RingOut call/Call history',
  clickToSMSCallHistory: 'Click To SMS (Call History)',
  callPlaceRingOutCallSMSHistory: 'Call: Place RingOut call/SMS history',
  inviteWithTextConference: 'Invite With Text (Conference)',
  selectAdditionalDialInNumber: 'Select Additional Dial-in Number (Conference)',
  joinAsHostConference: 'Join As Host (Conference)',
  whatsNew: "What's New",
  clickHoldAllCalls: 'Click Hold (All Calls)',
  clickHangupAllCalls: 'Click Hangup (All Calls)',
  clickRejectAllCalls: 'Click Reject (All Calls)',
  clickCallItem: 'Click Call Item (All Calls)',
  clickAddCallControl: 'Click Add (Call Control)',
  clickMergeCallControl: 'Click Merge (Call Control)',
  clickMergeMergeCallControl: 'Click Merge (Merge Call Control)',
  clickHangupMergeCallControl: 'Click Hangup (Merge Call Control)',
  callInboundCallConnected: 'Call: Inbound call connected',
  callOutboundRingOutCallConnected: 'Call: Outbound RingOut Call connected',
  clickAddCallsOnHold: 'Click Add (Calls OnHold)',
  clickMergeCallsOnHold: 'Click Merge (Calls OnHold)',
  clickCloseConfirmMergeModal: 'Click Close (ConfirmMerge Modal)',
  clickMergeConfirmMergeModal: 'Click Merge (ConfirmMerge Modal)',
  clickRemoveRemoveParticipantsModal: 'Click Remove (RemoveParticipants Modal)',
  cancelRemoveRemoveParticipantsModal:
    'Cancel Remove (RemoveParticipants Modal)',
  clickHangupParticipantList: 'Click Hangup (Participant List)',
  clickParticipantAreaCallControl: 'Click Participant Area (Call Control)',
  clickHangupCallsOnHold: 'Click Hangup (Calls OnHold)',
  clickMeetingSchedulePage: 'Meeting: Click Schedule/Meeting schedule page',
  clickRecentActivity: 'Recent Activity',
  clickRecentActivityCall: 'Recent Activity: Call',
  clickRecentActivitySms: 'Recent Activity: SMS',
  clickRecentActivityFaxes: 'Recent Activity: Faxes',
  clickRecentActivityVoicemails: 'Recent Activity: Voicemails',
  clickSaveLogSection: 'Click Save Call Log',
  clickCloseLogNotification: 'Click Stay or Close Notification',
  changeDailerDirectoryTab: 'Click to navigate in dialer search result pages',
  changeSMSDirectoryTab: 'Click to navigate in compose SMS search result pages',
  openEntityDetailLink: 'Click hyperlink to view record',
  completeWarmTransfer:
    'Transfer: Click complete transfer/Warm transfer call log page',
  clickConversationHyperlink: 'Click hyperlink/SMS conversation',
  executionReplyWithMessage: 'Reply incoming call with message.',
  clickToCallInContactDetails: 'Click To Dial (Contact Details)',
  clickToSMSInContactDetails: 'Click To SMS (Contact Details)',
  phoneConferenceCallMerge: 'Int_phone_conferenceCall_merge',
  clickParticipantsIcon: 'Int_phone_conferenceCall_participantList',
  clickRemoveParticipant: 'Int_phone_conferenceCall_removeParticipant',
  clickConfirmRemoveParticipant:
    'Int_phone_conferenceCall_removeParticipant_remove',
  getContactSearch: 'Int_Phone_contactSearch',
  searchedContactClicked: 'Int_Phone_searchedContactClicked',
  callMade: 'Int_Phone_callMade',
  transferAskFirst: 'Int_Phone_Transfer_askFirst',
  transferSwitchOnholdCall: 'Int_Phone_Transfer_switchonholdCall',
  transferToVoicemail: 'Int_Phone_Transfer_toVoicemail',
  transferCompleteTransfer: 'Int_Phone_Transfer_completeTransfer',
  toggleOnAutoLogTexts: 'Toggle on: auto SMS logging',
  newLogAutomatically: 'Call Log: New log automatically',
  newLogManually: 'Call Log: New log manually',
  contactSearchFromDialPad: 'Call: Contact search from dial pad',
  clickAddTextLogButton: 'Click Add text log button',
  clickSaveOnAddTextLog:
    'Click Save after click on Add text log when auto SMS log is on',
  clickFeedback: 'Feedback: Click Feedback Button/Settings',
  logSMSFromHistoryPage: 'SMS Log: Log SMS/Message history page',
  logSMSFromConversationPage: 'SMS Log: Log SMS/SMS conversation page',
  newSMSLogManually: 'SMS Log: New log manually',
  viewLogFromCallHistory: 'Int_Phone_callHistory_viewLog',
  uploadRingtone: 'Int_Audio_uploadRingtone',
  deleteRingtone: 'Int_Audio_deleteRingtone',
  smsSaveLogManually: 'Int_SMS_saveLogManually',
  smsSaveLogAutomatically: 'Int_SMS_saveLogAutomatically',
  clickOnIntegrationConsole:
    'Int_ActSync_Settings_ClientAutoCallLog_IntegrationConsole',
  clickOnTryEnhancedCallLogLink: 'Int_ActSync_Settings_ClientAutoCallLog_Try',
  clickAdminSetupNowOnPromotionalScreen:
    'Int_ActSync_PromotionalScreen_Admin_SetupNow',
  clickAdminLearnMoreOnPromotionalScreen:
    'Int_ActSync_PromotionalScreen_Admin_LearnMore',
  clickUserLearnMoreOnPromotionalScreen:
    'Int_ActSync_PromotionalScreen_User_LearnMore',
} as const);
